module.exports = __webpack_public_path__ + "static/media/icon-moduleE6.9cc72918.png";